module.exports = __webpack_public_path__ + "img/Mstorybg401.24aa7c05.png";